var _path, _circle, _circle2, _g, _ellipse, _circle3, _ellipse2, _circle4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53954 0.824862C7.09196 0.350429 7.90804 0.350429 8.46046 0.824862C8.81584 1.13007 9.29513 1.2482 9.75165 1.14311C10.4613 0.979745 11.1839 1.35899 11.4525 2.03581C11.6254 2.47121 11.9949 2.79855 12.4479 2.91765C13.1522 3.10277 13.6158 3.77439 13.5391 4.49853C13.4898 4.96439 13.6649 5.42594 14.0107 5.74194C14.5483 6.23315 14.6466 7.04328 14.2422 7.64886C13.9821 8.03844 13.9226 8.52847 14.0819 8.96899C14.3297 9.65375 14.0403 10.4168 13.4008 10.7651C12.9894 10.9891 12.709 11.3954 12.6454 11.8595C12.5465 12.581 11.9356 13.1221 11.2075 13.1333C10.7391 13.1405 10.302 13.3699 10.03 13.7513C9.60718 14.3442 8.81483 14.5395 8.16491 14.211C7.74682 13.9997 7.25318 13.9997 6.83509 14.211C6.18517 14.5395 5.39282 14.3442 4.96998 13.7513C4.69797 13.3699 4.26088 13.1405 3.79248 13.1333C3.06438 13.1221 2.45354 12.581 2.35465 11.8595C2.29103 11.3954 2.01062 10.9891 1.59922 10.7651C0.959726 10.4168 0.670343 9.65375 0.918053 8.96899C1.07741 8.52847 1.01791 8.03844 0.75776 7.64886C0.353374 7.04328 0.451741 6.23315 0.989302 5.74194C1.33512 5.42594 1.51017 4.96439 1.46087 4.49853C1.38423 3.77439 1.84781 3.10277 2.55207 2.91765C3.00514 2.79855 3.37462 2.47121 3.54746 2.03581C3.81613 1.35899 4.53873 0.979745 5.24835 1.14311C5.70487 1.2482 6.18416 1.13007 6.53954 0.824862Z",
    fill: "url(#paint0_linear_61_16937)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49437,
    cy: 7.46263,
    r: 5.28002,
    fill: "#705100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_16937",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.77619,
    cy: 8.02668,
    r: 5.29231,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_16937)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.49397,
    cy: 7.46296,
    r: 5.29231,
    fill: "#E3A504"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.64341,
    cy: 7.72706,
    rx: 4.15708,
    ry: 4.22413,
    fill: "#A36D1D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 7.64376,
    cy: 7.65988,
    r: 3.88888,
    fill: "url(#paint1_linear_61_16937)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.71069,
    cy: 7.65982,
    rx: 2.21264,
    ry: 2.27969,
    fill: "#B5760C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 7.71086,
    cy: 7.5927,
    r: 2.07854,
    fill: "url(#paint2_linear_61_16937)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_16937",
    x1: 7.5,
    y1: 0,
    x2: 7.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_16937",
    x1: 7.64376,
    y1: 3.771,
    x2: 7.64376,
    y2: 11.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D79B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_16937",
    x1: 7.71086,
    y1: 5.51416,
    x2: 7.71086,
    y2: 9.67124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFDA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D224"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/SignatureIcon.a045aaf92f769e5aec5b9fc686b472f6.svg";
export { ForwardRef as ReactComponent };